import { useEffect, useState } from "react";
import { AdminService } from "../../../../../ApplicationCode/Admin/AdminService";
import { RegisterLoader } from "../../RegisterContainer";
import { useNavigate } from "react-router-dom";
import { HttpHelper } from "../../../../../Core/Http/HttpHelper";
import { Text, FontIcon, Stack, Image, ImageFit } from "@fluentui/react";
import { t } from "i18next";
import { useBreakpoint } from "../../../Container/ContainerStyles";
import { BreakpointType, ContainerFluid } from "../../../Container/ContainerFluid";

import contactImg from "../../../../../Assets/Images/bkg_contatti.png";
import { iconStyles, imageContainerClassName, mdlgIconStyles, mdlgTextStyles, messageContainerStyles, smIconStyles, smTextStyles, textStyles } from "./Styles/RegisterEmailStyles";

export const RegisterEmail: React.FC = () => {
    const [error, setError] = useState<boolean>(false);
    const navigate = useNavigate();

    const adminService = new AdminService();

    //#region Methods

    const handleUser = () => {
        let attempts = 0;
        const maxAttempts = 13;
        
        const email = HttpHelper.getParameter("email");
        if (!email)
            navigate("/login");
        
        const fetchData = async () => {
            try {
                const user = await adminService.getUserByEmail(email);
                let url: string = "/login?email="+btoa(user.privateEmail);
                navigate(url);
                
                return;
            } catch (error) {
                console.log('error:'+error);
            }
            
            attempts++;
            if (attempts < maxAttempts) {
                setTimeout(fetchData, 5000);
            } else {
                setError(true);
            }
        };

        fetchData();
    }

    useEffect(() => {
        //Handle the lead
        handleUser();
    }, []);
    
    //#endregion

    return (
        <ContainerFluid
            centered
        >
            <Stack
                verticalFill
                verticalAlign="center"
            >
                <Stack>
                    {
                        error ?
                            <RegisterEmailError />
                        :
                            <RegisterLoader
                                label={t("common:register:email:progress:label")!}
                            />
                        
                    }
                </Stack>
            </Stack>
        </ContainerFluid>
    )
};

//#region Register Email Error

const RegisterEmailError: React.FC = () => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);

    //#region Styles

    //#endregion

    return (
        <Stack
            horizontal={!isSM && !isMD && !isLG}
            horizontalAlign="center"
            verticalFill={isSM || isMD || isLG}
            verticalAlign="center"
        >
            <Stack
                className={imageContainerClassName}
            >
                <Image 
                    src={contactImg}  
                    imageFit={ImageFit.cover} 
                    alt="Contact" 
                />
            </Stack>
            <Stack
                verticalFill
                verticalAlign="center"
                horizontalAlign={isSM || isMD || isLG ? "center" : "start"}
                className={messageContainerStyles}
                tokens={{childrenGap: 10}}
            >
                <FontIcon 
                    iconName="MailCheck" 
                    className={isSM ? smIconStyles : isMD || isLG ? mdlgIconStyles : iconStyles}
                />
                <Text
                    className={isSM ? smTextStyles : isMD || isLG ? mdlgTextStyles :  textStyles} 
                >
                    {t("common:register:email:error:title")}
                    <br />
                    {t("common:register:email:error:description")}
                </Text>
            </Stack>
        </Stack>
    );
}

//#endregiom